// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__cHJNm","btnPrimary":"Button_btnPrimary__sNNsR","btnSecondary":"Button_btnSecondary__2pBUk","btnBlack":"Button_btnBlack__Kb6wN","btnLink":"Button_btnLink__2p9v-"};